import http from "../../http-common";

export default class {
  getVideoPage(eventCode: string) {
    let url = `/events/video/${eventCode}`;

    return http.get(url);
  }
}